export default __webpack_public_path__ + "assets/svg/Ball.645c25c333453bfcd7505dd77193ce62.svg";